import React, { useEffect, useState } from "react";
import { updateCustomer } from "../../services/Api";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { updateInfo } from "../../redux-setup/reducers/auth";
const Customer = () => {
  const login = useSelector(({ auth }) => auth.login);
  const customer = {};
  customer.fullName = login.currentCustomer?.fullName;
  customer.phone = login.currentCustomer?.phone;
  customer.address = login.currentCustomer?.address;
  //   const { fullName, phone, address, email } = login.currentCustomer;
  const id = login?.currentCustomer?._id;
  const email = login?.currentCustomer?.email;
  const [formInputs, setFormInputs] = useState(customer);
  const [alertUpdate, setAlertUpdate] = useState("");
  const [statusUpdate, setStatusUpdate] = useState(false);
  const dispatch = useDispatch();
  const changeFormInputs = (e) => {
    const { name, value } = e.target;
    return setFormInputs({ ...formInputs, [name]: value });
  };
  const clickUpdate = (e) => {
    e.preventDefault();
    updateCustomer(id, formInputs)
      .then(({ data }) => {
        setAlertUpdate("Cập nhật thông tin thành công!");
        setStatusUpdate(true);
        return dispatch(updateInfo(formInputs));
      })
      .catch((error) => {
        if (error.response.data === "phone exists") {
          setAlertUpdate("Số điện thoại đã tồn tại!");
        }
      });
  };
  return (
    <>
      {/*	Customer Form	*/}
      <div id="customer">
        {alertUpdate && (
          <div
            className={`alert ${
              statusUpdate ? "alert-success" : "alert-danger"
            } text-center`}
          >
            {alertUpdate}
          </div>
        )}
        <h3 className="text-center">Thông tin tài khoản</h3>
        <form method="post">
          <div className="row">
            <div id="customer-name" className="col-lg-6 col-md-6 col-sm-12">
              <input
                onChange={changeFormInputs}
                placeholder="Họ và tên (bắt buộc)"
                type="text"
                name="fullName"
                className="form-control"
                value={formInputs.fullName}
                required
              />
            </div>
            <div id="customer-pass" className="col-lg-6 col-md-6 col-sm-12">
              <input
                // onChange={changeFormInputs}
                disabled
                placeholder="Mật khẩu (bắt buộc)"
                type="password"
                name="password"
                className="form-control"
                value={123456}
                required
              />
            </div>
            <div id="customer-mail" className="col-lg-6 col-md-6 col-sm-12">
              <input
                // onChange={changeFormInputs}
                disabled
                placeholder="Email (bắt buộc)"
                type="text"
                name="email"
                className="form-control"
                value={email}
                required
              />
            </div>
            <div id="customer-phone" className="col-lg-6 col-md-6 col-sm-12">
              <input
                onChange={changeFormInputs}
                placeholder="Số điện thoại (bắt buộc)"
                type="text"
                name="phone"
                className="form-control"
                value={formInputs.phone}
                required
              />
            </div>
            <div id="customer-add" className="col-lg-12 col-md-12 col-sm-12">
              <input
                onChange={changeFormInputs}
                placeholder="Địa chỉ nhà riêng hoặc cơ quan (bắt buộc)"
                type="text"
                name="address"
                className="form-control"
                value={formInputs.address}
                required
              />
            </div>
          </div>
        </form>
        <div className="row">
          <div className="by-now col-lg-6 col-md-6 col-sm-12">
            <a onClick={clickUpdate} href="#">
              <b>Cập nhật ngay</b>
            </a>
          </div>
          <div className="by-now col-lg-6 col-md-6 col-sm-12">
            <a href="#">
              <b>Quay về trang chủ</b>
            </a>
          </div>
        </div>
      </div>
      {/*	End Customer Form	*/}
    </>
  );
};
export default Customer;
